import { PageHero } from "@/components/site/Sections";
import { CtaButton } from "@/components/site/CtaButton";
import { FAQS, LEGAL_DISCLAIMER, FINANCING_DISCLAIMER } from "@/data/content";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <div>
      <PageHero eyebrow="FAQ" title="Straight Answers for Serious Investors." subtitle="How Vertexhub works, what's included, and where our support begins and ends." />

      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-3xl px-4 lg:px-8">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="overflow-hidden rounded-xl border border-slate-200 bg-white px-5"
              >
                <AccordionTrigger className="text-left text-sm font-semibold text-[#0B132B] hover:text-gold hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-slate-500">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 space-y-4 rounded-xl border border-slate-200 bg-[#FAF8F1] p-6">
            <h4 className="font-mono-x text-xs uppercase tracking-widest text-gold">Legal Disclaimer</h4>
            <p className="text-xs leading-relaxed text-slate-500">{LEGAL_DISCLAIMER}</p>
            <h4 className="pt-2 font-mono-x text-xs uppercase tracking-widest text-gold">Financing Disclaimer</h4>
            <p className="text-xs leading-relaxed text-slate-500">{FINANCING_DISCLAIMER}</p>
          </div>

          <div className="mt-12 text-center">
            <CtaButton to="/contact">Still Have Questions? Contact Us</CtaButton>
          </div>
        </div>
      </section>
    </div>
  );
}
